export const SYSTEM_ADMIN_SELLER_ID = '100002';

const LD_CONTEXT_OVERRIDE_KEY = 'ss-admin-ld-context-override';

export const LdContextMode = {
  SELLER: 'seller',
  ADMIN: 'admin',
} as const;

export const getStoredLdContextMode = (): string => {
  return localStorage.getItem(LD_CONTEXT_OVERRIDE_KEY) ?? LdContextMode.SELLER;
};

export const setStoredLdContextMode = (mode: string): void => {
  localStorage.setItem(LD_CONTEXT_OVERRIDE_KEY, mode);
};

export const identifyLdUser = async (sellerId: string): Promise<void> => {
  if (!window.ldClient) {
    return;
  }

  const currentContext = window.ldClient.getContext();
  const updatedContext = {
    ...currentContext,
    custom: {
      ...currentContext?.custom,
      sellerId,
    },
  };

  await window.ldClient.identify(updatedContext);
};
